<template>
  <div class="container">
    <div class="card">
      <h1 class="title">DSGVO Generator</h1>

      <div class="form-group">
        <label>Firmenname</label>
        <input
          v-model="companyName"
          type="text"
          placeholder="Geben Sie Ihren Firmennamen ein"
        />
      </div>

      <div class="form-group">
        <label>Website URL</label>
        <input
          v-model="website"
          type="text"
          placeholder="https://www.example.com"
        />
      </div>

      <div class="form-group">
        <label>Kontakt E-Mail</label>
        <input v-model="email" type="email" placeholder="kontakt@example.com" />
      </div>

      <div class="form-group">
        <label>Beschreibung der Datenverarbeitung</label>
        <input
          v-model="dataProcessing"
          type="text"
          placeholder="Beschreiben Sie kurz die Art der verarbeiteten Daten"
        />
      </div>

      <button @click="generateDSGVO" class="btn-primary">Generate DSGVO</button>

      <div v-if="generatedDSGVO" class="output">
        <h2>Generierte Datenschutzerklärung</h2>
        <p>{{ generatedDSGVO }}</p>

        <div class="buttons">
          <button @click="copyDSGVO" class="btn-secondary">Copy</button>
          <button @click="downloadDSGVO" class="btn-download">Download</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DSGVOGenerator",
  data() {
    return {
      // Standardwerte als Beispiel
      companyName: "E-Sell Gmbh",
      website: "https://www.eSell.ch",
      email: "kontakt@eSell.ch",
      dataProcessing: "Nutzer- und Bestelldaten im Rahmen des Onlinehandels",
      generatedDSGVO: "",
    };
  },
  methods: {
    async generateDSGVO() {
      // Simulierter DSGVO-Text, in dem die Eingaben verwendet werden.
      const mockResponse = {
        response: `Datenschutzerklärung

Diese Datenschutzerklärung klärt Sie über die Art, den Umfang und den Zweck der Verarbeitung personenbezogener Daten innerhalb unseres Onlineangebotes und der mit ihm verbundenen Webseiten, Funktionen und Inhalte (nachfolgend gemeinsam bezeichnet als "Onlineangebot") auf. Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist ${this.companyName}.

Kontakt:
Website: ${this.website}
E-Mail: ${this.email}

Datenschutz bei der Nutzung unseres Onlineangebotes:
Wir erheben und verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur Bereitstellung eines funktionsfähigen und nutzerfreundlichen Angebotes erforderlich ist. Die Erhebung, Verarbeitung und Nutzung Ihrer Daten erfolgt auf Grundlage der DSGVO und anderer datenschutzrechtlicher Bestimmungen.

Art der verarbeiteten Daten:
Im Rahmen der Nutzung unseres Onlineangebotes verarbeiten wir insbesondere folgende Daten: ${this.dataProcessing}. Diese Daten werden ausschließlich zu dem Zweck verarbeitet, Ihnen unsere Dienstleistungen anzubieten und unseren Service kontinuierlich zu verbessern.

Rechtsgrundlagen der Verarbeitung:
Die Verarbeitung Ihrer personenbezogenen Daten erfolgt auf Basis der gesetzlichen Bestimmungen der DSGVO. Insbesondere stützen wir unsere Verarbeitung auf Art. 6 Abs. 1 lit. f DSGVO, sofern ein berechtigtes Interesse an der Datenverarbeitung besteht.

Weitergabe von Daten:
Eine Weitergabe Ihrer Daten an Dritte erfolgt nur, wenn dies zur Erfüllung des Vertragszwecks notwendig ist oder wir gesetzlich dazu verpflichtet sind. Eine darüberhinausgehende Weitergabe erfolgt nicht.

Ihre Rechte:
Sie haben das Recht, Auskunft über die bei uns gespeicherten personenbezogenen Daten zu erhalten, sowie das Recht auf Berichtigung, Löschung, Einschränkung der Verarbeitung, Widerspruch gegen die Verarbeitung und das Recht auf Datenübertragbarkeit. Zur Ausübung dieser Rechte können Sie sich jederzeit an ${this.email} wenden.

Datensicherheit:
Wir setzen technische und organisatorische Maßnahmen ein, um Ihre Daten gegen zufällige oder vorsätzliche Manipulationen, Verlust, Zerstörung oder den Zugriff unberechtigter Personen zu schützen.

Änderungen dieser Datenschutzerklärung:
Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um sie stets den aktuellen rechtlichen Anforderungen anzupassen oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen. Es gilt jeweils die zum Zeitpunkt Ihres Besuchs aktuell gültige Fassung.

Mit der Nutzung unseres Onlineangebotes erklären Sie sich mit der Erhebung, Verarbeitung und Nutzung der zur Erfüllung des Vertragszwecks erforderlichen Daten einverstanden.`,
      };

      this.generatedDSGVO = `Datenschutzerklärung von ${this.companyName}\n\n${mockResponse.response}`;
    },

    copyDSGVO() {
      navigator.clipboard.writeText(this.generatedDSGVO);
      alert("Datenschutzerklärung in die Zwischenablage kopiert!");
    },
    downloadDSGVO() {
      const blob = new Blob([this.generatedDSGVO], { type: "text/plain" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Datenschutzerklaerung.txt";
      link.click();
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f3f4f6;
  padding: 20px;
}

.card {
  width: 100%;
  max-width: 600px;
  background: white;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

/* Typography */
.title {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  color: #333;
  margin-bottom: 20px;
}

/* Form Elements */
.form-group {
  margin-bottom: 15px;
}

label {
  font-weight: 600;
  color: #444;
  display: block;
  margin-bottom: 5px;
}

input,
select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  transition: 0.3s;
}

input:focus,
select:focus {
  border-color: #333;
  outline: none;
}

/* Buttons */
.btn-primary {
  width: 100%;
  padding: 12px;
  background: #333;
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.3s;
}

.btn-primary:hover {
  background: #444;
}

.btn-secondary,
.btn-download {
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;
}

.btn-secondary {
  background: #e5e7eb;
  color: #333;
}

.btn-secondary:hover {
  background: #d1d5db;
}

.btn-download {
  background: #10b981;
  color: white;
}

.btn-download:hover {
  background: #059669;
}

/* Output Section */
.output {
  background: #f9fafb;
  padding: 20px;
  border-radius: 8px;
  margin-top: 20px;
}

.output h2 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.output p {
  white-space: pre-line;
  color: #555;
}

.buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
</style>
